// extracted by mini-css-extract-plugin
export default {"news_box":"index_news_box_mzD8N clearfix","box_l":"index_box_l_kohUw","box_r":"index_box_r_iGUII"};